import { buildSchema, DeepLinkBuildingProps } from '~/utils/active/schema';
import { EClickPosition } from 'shared/constant';
import { createStore, useStore } from 'jotai';
import { $SharingEnterTraffic, $SharingCurrentTraffic } from 'shared/atoms';
import { $ABTest } from '@lemon8/web-app-shared/atom';
import { useMemo } from 'react';
import { SharingCurrentTrafficUtil, SharingEnterTrafficUtil } from 'shared/utils';

export interface IDeepLinkProps {
  store?: ReturnType<typeof createStore>;

  schemaOption: DeepLinkBuildingProps;
  ampExtraOption?: {
    clickPosition?: EClickPosition;
    clickId?: string;
  };
}

export const buildDeepLink = (props: IDeepLinkProps): string => {
  const { store = window.store, schemaOption, ampExtraOption } = props;

  const { versions } = store.get($ABTest);
  const enterTraffic = store.get($SharingEnterTraffic);
  const currentTraffic = store.get($SharingCurrentTraffic);

  const schema = new URL(buildSchema(schemaOption));

  schema.searchParams.set('ab_version', versions);

  schema.searchParams.set(
    'amp_extra',
    JSON.stringify({
      traffic_type: enterTraffic.trafficPid,
      is_from_wap: 0,

      // debug
      // share_user_id: rootTraffic.sharerUid,
      // share_device_id: rootTraffic.sharerDid,
      // share_time: rootTraffic.shareTime,

      _t: enterTraffic.sharerToken,
      share_platform: enterTraffic.sharePlatform || null,

      // share content extra
      ...SharingEnterTrafficUtil.getShareContentExtra(enterTraffic),

      // enter page extra
      ...SharingCurrentTrafficUtil.getEnterPageExtra(currentTraffic),

      // cta extra
      enter_position: ampExtraOption?.clickPosition || null,
      enter_page_click_id: ampExtraOption?.clickId || null,
    }),
  );

  return schema.toString();
};

export const useDeepLink = (schemaOption: DeepLinkBuildingProps): string => {
  const store = useStore();

  return useMemo(
    () =>
      buildDeepLink({
        store,
        schemaOption,
      }),
    [],
  );
};
